export const HANDLE_SCROLL_DELAY = 150;
export const MAX_SCROLL_KEYS = 30;
export const SCROLL_POSITIONS_KEY = 'SCROLL_POSITIONS';
export const NAVIGATION_BACK = 'POP';
export const NAVIGATION_REPLACE = 'REPLACE';
